import React, { useEffect, useState, useRef } from "react";
import Layout from "../../../components/mobile/Layout/layoutmobileempty";
import { getcategory } from "../../../service/myProductService";
import { getMyProduct, getProductSearch } from "../../../service/myProductService";
import { Item } from "../../../components/mobile/product";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { pushtracking } from "../../../service/trackingService";
import { useLocation } from "@reach/router";
import {getListSuggest} from '../../../service/searchService';

import './css/tim-kiem.css';
const Search=()=> {
    const location = useLocation();
    var param = '';
    try {
        param = decodeURI(location.search?.replace('?', '').replaceAll('=', ''))
      } catch (e) {
        // console.error(e);
      }
    const [category, setCategory] = useState([]);
    const [childCategory, setChildCategory] = useState([]);
    const [categoryId, setCategoryId] = useState('');
    const [childBefor, setChildBefor] = useState([]);
    const getDataCategory = () => {
        try {
            getcategory().then((response) => {
                if (response.status == 200 && response.message.length > 0 && response.message !== "Không tìm thấy dữ liệu.") {
                    setCategory(response.message);
                    var obj = {};
                    setCategoryId(response.message[0]._id);
                    response.message.forEach(element => {
                        if (element.children.length > 0) {
                            obj[element._id] = element.children;
                        }
                    });
                    setChildCategory(obj);
                    setChildBefor(response.message[0].children);
                }
            });
        } catch (e) {
            console.log(e);
        }
    }

    const textSearchRef = useRef('');
    const [dataList, setDataList] = useState([]);
    const [loadMoreStart, setLoadMoreStart] = useState(0);
    const [totalItem, setTotalItem] = useState(0);
    const [noData, setNoData] = useState(false);
    const [keyword, setKeyword] = useState('');
    const fetchData = (start, text) => {
        setLoading(true);
        setDataList([]);
        try {
            getMyProduct('', start, '', '', '', text).then((response) => {
                if (response.status !== 426 || response.status !== 500) {
                    if (response.status === 200 && response.message.length > 0 && response.message !== "Không tìm thấy dữ liệu.") {
                        setDataList((prevData) => [...prevData, ...response.message]);
                        setLoading(false);
                        setNoData(false);
                        setTotalItem(response.metadata?.total_item);
                        setKeyword(text);
                        setLoadMoreStartProduct(0);
                    }
                    if (response.status === 200 && response.message.length === 0) {
                        setLoading(false);
                        setNoData(true);
                    }
                }
            });
            document.activeElement.blur();
        } catch (e) {
            console.log(e);
        }
    };
    const getProductLoadMore = (start, text) => {
        try {
            getMyProduct('', start, '', '', '', text).then((response) => {
                if (response.status !== 426 || response.status !== 500) {
                    if (response.status === 200 && response.message.length > 0 && response.message !== "Không tìm thấy dữ liệu.") {
                        setDataList((prevData) => [...prevData, ...response.message]);
                        setTotalItem(response.metadata?.total_item);
                    }
                }
            });
        } catch (e) {
            console.log(e);
        }
    };
    const handleBack = () => {
        window.history.back();
        window.localStorage.removeItem('keysearchcurrent');
    }

    const handleClickGetProductByCategiryId = (id, name) => {
        setCategoryId(id);
        window.localStorage.setItem("titleCate", name);
        window.location.href = '/mobile/danh-sach-san-pham.html?div=' + id;
    }
    const [itemProductSearch, setItemProductSearch] = useState([]);
    const getDataProductSearch = () => {
        try {
            getProductSearch().then((response) => {
                if (response.status === 200 && response.message.length > 0 && response.message !== "Không tìm thấy dữ liệu.") {
                    setItemProductSearch(response.message);
                }
            });
        } catch (e) {
            console.log(e);
        }
    }
    const [keySearchCurrent, setKeySearchCurrent] = useState(false);
    useEffect(() => {
        if (!window.localStorage.getItem("keysearch")) {
            window.localStorage.setItem('keysearch', '');
        } else {
            setListSearch(JSON.parse(window.localStorage.getItem("keysearch")));
        }
        window.localStorage.setItem('keysearchcurrent', param);
        if (param || param !== '') {
            setKeySearchCurrent(true);
            fetchData(0, param);
        }
        try{
            var _sku_list = [];
            dataList.forEach((item)=>{
                _sku_list.push(item?.sku);
            });
            pushtracking(window.localStorage.getItem('sessionId')??null,
            window.localStorage.getItem('_id')??null,
            window.localStorage.getItem('phone')??null ,
            location.pathname, "Tìm kiếm sản phẩm", 0,0,'index','inWeb',_sku_list,'Website Mobile').then((response)=>{
                console.log('send tracking');
            });
        }catch(e){console.log(e)}
        getDataProductSearch();
        getDataCategory();
    }, [])
    var array_key = [];
    const [listSearch, setListSearch] = useState([]);
    const addKeyWord = (keyword) => {
        if (window.localStorage.getItem("keysearch")) {
            array_key = JSON.parse(window.localStorage.getItem("keysearch"));
        }
        array_key.forEach((item, key) => {
            if (item === keyword) {
                array_key.splice(key, 1);
            }
        })
        array_key.push(keyword);
        window.localStorage.setItem('keysearch', JSON.stringify(array_key));
        window.localStorage.setItem('keysearchcurrent', keyword);
        setListSearch(array_key);
    }
    const handleSearch = () => {
        let _keywword = textSearchRef.current.value;
        if (_keywword === '') {
            setDataList([]);
            toast.warning('Bạn chưa nhập thông tin tìm kiếm.');
        } else {
            addKeyWord(_keywword);
            // fetchData(0, _keywword);
            window.location.replace('/ket-qua-tim-kiem.html?'+encodeURI(_keywword));
        }
    }
    const [dataSuggest, setDataSuggest] = useState([]);
    const handleKeyPress = (e) => {
        try {
            getListSuggest(textSearchRef.current.value).then((response)=>{
                if(response.status === 200){
                    setDataSuggest(response.message);
                }
            })
        } catch (error) {
            console.log(error);
        }

        if (e.key === 'Enter') {
            let _keywword = textSearchRef.current.value;
            if (_keywword === '') {
                setDataList([]);
                toast.warning('Bạn chưa nhập thông tin tìm kiếm.');
            } else {
                addKeyWord(_keywword);
                window.location.replace('/ket-qua-tim-kiem.html?'+encodeURI(_keywword));
            }
        }
    }

    const handleSearchText =(text)=>{
        if(text === ''){
            toast.warning('Bạn chưa nhập thông tin tìm kiếm.');
        }else{
            addKeyWord(text);
            window.location.replace('/ket-qua-tim-kiem.html?'+encodeURI(text));
        }
      }

    const handleSearchClick = (key) => {
        addKeyWord(key);
        fetchData(0, key);
    }
    const handleClear = () => {
        window.localStorage.removeItem('keysearch');
        setListSearch([]);
    }
    const handleClose = () => {
        window.localStorage.removeItem('keysearchcurrent');
        setKeySearchCurrent(false);
        setDataList([]);
        textSearchRef.current.value = '';
    }
    const handleRedirect = (uri) => {
        window.location.reload('/mobile' + uri);
    }
    const handleInputBlur = () => {
        document.activeElement.blur();
    };
    const [loading, setLoading] = useState(false);
    const InfiniteScroll = ({ loadMore }) => {
        useEffect(() => {
          const handleScroll = () => {
            var check = Math.abs(parseInt(window.innerHeight +document.documentElement.scrollTop) - parseInt(document.documentElement.offsetHeight)) 
            if (check === 0 || check === 1) {
                loadMore();
             }
          };
      
          window.addEventListener("scroll", handleScroll);
          return () => {
            window.removeEventListener("scroll", handleScroll);
          };
        }, [loadMore]);
      
        return null;
    };
    const [loadMoreStartProduct, setLoadMoreStartProduct] = useState(0);
    const handleLoadMoreProduct = (e) => {
        setLoadMoreStartProduct(0);
        const newStart = loadMoreStartProduct + 1;
        setLoadMoreStartProduct(newStart);
        getProductLoadMore(newStart,keyword);
    };
    
    return (
        <Layout>
            {
                loading === true ? (<div className="module so-deals-ltr deal-layout33">
                    <div className="detail-cart-left w-100 h-100 pdx-10">
                        <div id="landing-web">
                            <div className="loading-page-app-item pdt-50" style={{ textAlign: "center" }}>
                                <img src="/../images/loading.gif" alt="icon" />
                            </div>
                        </div>
                    </div>
                </div>) : (null)}

            <Helmet>
                <body className="" />
            </Helmet>
            <div className="row header headerv2 fixed bottom mgx-0">
                <div className="row in-f pdx-10 pdy-10 mgx-0">
                    <div className="col-1 in-f">
                        <i className="fa-solid fa fa-chevron-left" onClick={handleBack}></i>
                    </div>
                    <div className="col-10">
                        <input ref={textSearchRef} className="search-input text-search" type="text" name="search"
                            placeholder="Ba Mẹ cần tìm gì cho bé hôm nay?" onKeyDown={handleKeyPress} autoFocus
                            onTouchStart={handleInputBlur} defaultValue={param}/>
                    </div>
                    <div className="col-1 in-f">
                        {
                            dataList.length > 0 ? (<i className="fa fa-xmark close-result-search" onClick={handleClose}></i>) : (<img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/search_black.png" alt="icon" onClick={handleSearch} />)
                        }
                    </div>
                    {
                        dataSuggest.length > 0 ? (
                            <div className="suggest">
                                <ul>
                                    {
                                        dataSuggest.map((item,i)=>{
                                        return <li key={i} onClick={()=>handleSearchText(item)}>{item}</li>
                                        }) 
                                    }
                                </ul>
                            </div>
                        ):(null)
                    }
                </div>
            </div>
            <div style={{ height: 50 }}></div>
            {
                noData === true && loading === false ? (
                    <>
                        <div className="text-center">
                            <span className="text-center text-normal-13">Không tìm thấy kết quả phù hợp!</span>
                        </div>
                        <div style={{ height: 15 }}></div>
                    </>
                ) : (null)
            }
            {
                dataList.length > 0 ? (
                    <>
                        <ul className="row col-ul-1 mgx-0 pdx-8">
                            {
                                dataList.length > 0 ?
                                    (
                                        dataList.map((item, j) => {
                                            return <Item item={item} index={item.sku + j} />
                                        })
                                    )
                                    :
                                    (null)
                            }
                        </ul>
                        <InfiniteScroll loadMore={handleLoadMoreProduct} />
                        {
                            +totalItem - +dataList.length > 0 ? (
                                <div className="loading-page-app-item pdy-5" style={{ textAlign: "center" }}> <img src="/../images/loading.gif" alt="icon" /></div>
                            ) : (null)
                        }
                    </>
                ) : (
                    <div className="wp-page-search pdx-20">

                        {listSearch.length > 0 && !keySearchCurrent ? (
                            <div className="row mgt-10 mgx-0 pdx-0">
                                <div className="col-6">
                                    <h3 className="title-1 title-2">Lịch sử tìm kiếm</h3>
                                </div>
                                <div className="col-6">
                                    <div className="title-2 delete-his" onClick={handleClear}>Xóa lịch sử</div>
                                </div>

                                <ul className="pdx-0 his_search">
                                    {
                                        listSearch.map((item, key) => {
                                            return <li><a onClick={() => handleSearchClick(item)}>{item}</a></li>
                                        })
                                    }
                                </ul>
                            </div>
                        ) : (null)}

                        {
                            itemProductSearch.length > 0 && !keySearchCurrent ? (
                                <div className="row mgt-10 mgx-0 pdx-0">
                                    <h3 className="title-1">Tìm kiếm phổ biến</h3>
                                    <ul className="item-phobien">
                                        {
                                            itemProductSearch.map((item, i) => {
                                                return <li onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                                                    <div className="row mgt-10 mgx-0 pdx-0">
                                                        <div className="col-3 img-item in-f">
                                                            <img src={item.thumbnail_mini} alt={item.name} />
                                                        </div>
                                                        <div className="col-9 mgt-5">
                                                            <div className="col-12 box-name-item d-flex mgt-10 pdr-5"><span className="name-item">{item.name}</span></div>
                                                        </div>
                                                    </div>
                                                </li>
                                            })
                                        }

                                    </ul>
                                </div>
                            ) : (null)
                        }

                        {
                            !keySearchCurrent ? (
                                <>
                                    <div className="row mgt-10 mgx-0 pdx-0">
                                        <h3 className="title-1">Danh mục nổi bật</h3>
                                    </div>
                                    <div className="row pdb-10 mgx-0 pdx-0">
                                        {
                                            category.length > 0 ? (
                                                <ul className="danh-muc-noi-bat pdx-0">
                                                    {
                                                        category.map((item, i) => {
                                                            return <li key={i} className={"cate-item"} onClick={() => handleClickGetProductByCategiryId(item._id, item.name)}>
                                                                <div className='row pdx-0 mgx-0'>
                                                                    <div className='col-3 img'><img src={item.icon?.selected} /></div>
                                                                    <div className='col-9'><span>{item.name}</span></div>
                                                                </div>
                                                            </li>
                                                        })
                                                    }
                                                </ul>

                                            ) : (null)
                                        }
                                    </div>
                                </>
                            ) : (
                                null
                            )
                        }


                    </div>
                )
            }
        </Layout>
    )
}
export default Search;